"use client";

import { useState } from "react";
import { Check, Code } from "lucide-react";
import { useDictionary } from "@/libs/DictionaryProvider";
import { embedSnippet } from "@/libs/calculatorEmbeds";

// "Embed this calculator": the copy-paste code for other sites (see
// src/libs/calculatorEmbeds.ts).
const CalculatorEmbedCode = ({
  lang,
  slug,
  name,
}: {
  lang: string;
  slug: string;
  name: string;
}) => {
  const t = useDictionary().calculator_embed;
  const [copied, setCopied] = useState(false);
  const code = embedSnippet({ lang, slug, name, byText: t.by });
  if (!code) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="mt-10 rounded-lg border border-white/[0.12] bg-dark-8 p-5 text-white">
      <h2 className="flex items-center gap-2 text-xl font-semibold mb-2">
        <Code size={20} /> {t.heading}
      </h2>
      <p className="mb-3 text-sm text-gray-300">{t.intro}</p>
      <textarea
        readOnly
        value={code}
        rows={5}
        onFocus={(event) => event.currentTarget.select()}
        aria-label={t.heading}
        className="w-full rounded-lg border border-white/[0.12] bg-dark-7 p-3 font-mono text-xs leading-relaxed text-gray-200 outline-none"
      />
      <button
        type="button"
        onClick={copy}
        className="hero-button-gradient mt-3 flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold text-white hover:opacity-80 transition duration-200"
      >
        {copied ? <Check size={16} /> : <Code size={16} />}
        {copied ? t.copied : t.copy}
      </button>
    </div>
  );
};

export default CalculatorEmbedCode;
